import { createContext, useContext, useEffect } from "react";

// Names for the top bar's breadcrumb (047 D11). A page that knows a name — the student,
// the parent, the child — hands it up, keyed by the id in its URL; the Layout keeps them.
// Outside the Layout the default does nothing.
export const BreadcrumbContext = createContext(() => {});

export const useBreadcrumbName = (key, name) => {
  const setCrumbName = useContext(BreadcrumbContext);
  useEffect(() => {
    if (!key || !name) return undefined;
    setCrumbName(key, name);
    return () => setCrumbName(key, undefined);
  }, [key, name, setCrumbName]);
};
